import * as Sentry from "@sentry/nextjs";
import toast from "react-hot-toast";
import { QOOHOO_WEBSITE_DOMAIN } from "constants/env";
import httpf from "utils/api/frontend/httpf";
import axios from "axios";
import * as Posthog from "@qoohoo/common/utils/analytics/posthog";
import { maskNumber } from "@qoohoo/common/utils/string";
import useCustomerStore from "store/customerStore";
import CustomerModel from "models/CustomerModel";
import getAuthMe from "helpers/getAuthMe";

export async function sendOtp(phone, countryCode, sendInWhatsapp, turnstileToken, setIsLoading) {
    if (phone.length <= 4 || !countryCode) {
      toast.error("Enter correct phone number");
      return false;
    }

    setIsLoading(true);

    const data = {
      current_screen: "checkout_view",
      current_route: window.location.pathname,
      otp_type: sendInWhatsapp? "whatsapp" : "sms",
      // payment_gateway: "razorpay",
      phone_number: maskNumber(phone),
      country_code: countryCode,
      platform: "web",
    };

    console.log("Posthog button click data: send_otp_button", data);

    Posthog.buttonClick("send_otp_button", data);

    return await httpf
      .post(`${QOOHOO_WEBSITE_DOMAIN}/api/auth/mobile/request`, {
        mobile: phone,
        countryCode: countryCode,
        sendInWhatsapp: sendInWhatsapp,
        turnstileToken: turnstileToken,
      })
      .then(() => {
        toast.success("OTP sent successfully.");

        return true;
      })
      .catch((err) => {
        console.error(err);

        Sentry.captureException(err, {
          extra: {
            countryCode: countryCode,
            mobile: maskNumber(phone)
          }
        });

        const errors =
        err?.response?.data?.data?.message ||
        err?.response?.data?.message ||
        err?.response?.data?.data?.non_field_errors ||
        err?.response?.data?.non_field_errors ||
        err?.response?.data?.data;

        if (errors && (!(errors instanceof Array) || errors.length > 0)) {
          toast.error(errors);
        } else {
          toast.error("Error sending OTP");
        }
      }).finally(()=>{
        setIsLoading(false);
      });
  }

export async function verifyOtp(phone, countryCode, otp, setIsLoading, whatsapp_opt_in) {

  const setCustomer = useCustomerStore.getState().setCustomer;

  setIsLoading(true);

  if (otp.length < 6) {
    toast.error("Please enter 6 digit OTP");
    setIsLoading(false);
    return false;
  }

  const data = {
    current_screen: "checkout_view",
    current_route: window.location.pathname,
    // payment_gateway: "razorpay",
    phone_number: maskNumber(phone),
    country_code: countryCode,
    platform: "web",
  };

  console.log("Posthog button click data: verify_otp_button", data);

  Posthog.buttonClick("verify_otp_button", data);

  const payload = {
    mobile: phone,
    countryCode,
    otp: otp,
    whatsapp_opt_in: whatsapp_opt_in || null,
  };

  return await httpf
    .post(`${QOOHOO_WEBSITE_DOMAIN}/api/auth/mobile/validate`, payload, {withCredentials: true})
    .then(async () => {
      try {
        const res = await getAuthMe();

        if (res) {
          const _customer = new CustomerModel(res.data);
          setCustomer(_customer);

          const userProperties = {
            user_uid: res.data.uid,
            $name: res.data.name,
            $username: res.data.username,
            };

          const data = {
            user_uid: res.data.uid,
            current_screen: "checkout_view",
            current_route: window.location.pathname,
            // payment_gateway: "razorpay",
            phone_number: maskNumber(phone),
            country_code: countryCode,
            platform: "web",
          };
        
          console.log("Posthog login event data: login_successful", userProperties, data);
          
          Posthog.setUniqueUserID(res.data.uid);
          Posthog.addProperties(userProperties);

          Posthog.buttonClick("login_successful", data);

          toast.success("OTP verified successfully");

          return true;
        } else {
          console.log(res);

          // toast.error("Some error occurred. Please refresh the page");

          throw new Error('Invalid res');
        }

      } catch(err) {
        Sentry.captureException(err, {
          extra: {
            isAfterLogin: true,
          }
        });

        const data = {
          current_screen: "checkout_view",
          current_route: window.location.pathname,
          // payment_gateway: "razorpay",
          phone_number: maskNumber(phone),
          country_code: countryCode,
          failure_reason: err?.response?.data?.message || err?.response?.data?.data?.message || err?.response?.data?.data || err?.response?.data || err?.message,
          platform: "web",
        };
      
        console.log("Posthog login event data: login_failed", data);
        
        Posthog.buttonClick("login_failed", data);

        if(err?.response?.status === 401) {
          Posthog.removeUniqueUserID();
          await logout();
        }
      }
    })
    .catch((err) => {
      console.log(err);

      const data = {
        current_screen: "checkout_view",
        current_route: window.location.pathname,
        // payment_gateway: "razorpay",
        phone_number: maskNumber(phone),
        country_code: countryCode,
        failure_reason: err?.response?.data?.message || err?.response?.data?.data?.message || err?.response?.data?.data || err?.response?.data || err?.message,
        platform: "web",
      };
    
      console.log("Posthog login event data: incorrect_otp", data);
      
      Posthog.buttonClick("incorrect_otp", data);
      
      if(err?.response?.status !== 400) {
        Sentry.captureException(err);
      }
      
      toast.error("Error verifying OTP! Please try again.");
    })
    .finally(() => {
      setIsLoading(false);
    });
}

export async function logout(){
  const setCustomer = useCustomerStore.getState().setCustomer;

  await axios.get(`${QOOHOO_WEBSITE_DOMAIN}/api/auth/logout`, { withCredentials: true }).finally(() => {
    toast.error("Some error occurred, please login again.");

    const _customer = new CustomerModel();
    setCustomer(_customer);
  });
}